/**
 * DG Collection – Inline Filters & Sticky Cart
 * v5 — Replaces bottom sheet with inline dropdown popovers
 */
document.addEventListener('DOMContentLoaded', () => {

    /* ═══════════════════════════════════════════════════════════════
       INLINE FILTER POPOVERS
       ═══════════════════════════════════════════════════════════════ */
    (function dgInlineFilters() {
        const container = document.getElementById('dg-inline-filters');
        if (!container) return;

        const dropdowns = container.querySelectorAll('.dg-filter-dropdown');

        const isMobile = () => window.innerWidth <= 767;

        /* ── Backdrop ───────────────────────────────────────────── */
        let backdrop = null;

        function showBackdrop() {
            if (backdrop) return;
            backdrop = document.createElement('div');
            backdrop.className = 'dg-filter-backdrop';
            
            const pageContainer = document.querySelector('.dg-collection-page') || document.body;
            pageContainer.appendChild(backdrop);
            
            backdrop.addEventListener('click', closeAll);
            if (isMobile()) document.body.style.overflow = 'hidden';
        }

        function hideBackdrop() {
            if (backdrop) { backdrop.remove(); backdrop = null; }
            document.body.style.overflow = '';
        }

        /* ── Inject ✕ close button (mobile only) ───────────── */
        function addCloseBtn(popover) {
            if (popover.querySelector('.dg-sheet-close')) return;
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'dg-sheet-close';
            btn.setAttribute('aria-label', 'Fermer');
            btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
            btn.addEventListener('click', closeAll);
            popover.style.position = 'relative';
            popover.insertBefore(btn, popover.firstChild);
        }

        /* ── Close all popovers ─────────────────────────────── */
        function closeAll() {
            dropdowns.forEach(d => {
                const p = d.querySelector('.dg-filter-popover');
                const c = d.querySelector('.dg-filter-chip');
                if (p) {
                    p.hidden = true;
                    p.style.left = '';
                    p.style.right = '';
                }
                if (c) c.setAttribute('aria-expanded', 'false');
                d.classList.remove('is-open');
            });
            hideBackdrop();
        }

        /* ── Toggle a specific dropdown ─────────────────────────── */
        dropdowns.forEach(dropdown => {
            const chip = dropdown.querySelector('.dg-filter-chip');
            const popover = dropdown.querySelector('.dg-filter-popover');
            if (!chip || !popover) return;

            chip.addEventListener('click', (e) => {
                e.stopPropagation();
                const wasOpen = !popover.hidden;
                closeAll();

                if (!wasOpen) {
                    popover.hidden = false;
                    chip.setAttribute('aria-expanded', 'true');
                    dropdown.classList.add('is-open');
                    showBackdrop();

                    if (isMobile()) {
                        addCloseBtn(popover);
                    } else {
                        // Desktop: check right-edge overflow
                        requestAnimationFrame(() => {
                            const rect = popover.getBoundingClientRect();
                            if (rect.right > window.innerWidth - 8) {
                                popover.style.left = 'auto';
                                popover.style.right = '0';
                            }
                        });
                    }
                    // Mobile: CSS bottom-sheet handles position
                }
            });

            // Prevent clicks inside popover from closing it
            popover.addEventListener('click', (e) => e.stopPropagation());
        });

        /* ── Close on outside click or Escape ───────────────────── */
        document.addEventListener('click', closeAll);
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeAll();
        });

        /* ── Auto-submit filter on checkbox change ────────────── */
        container.addEventListener('change', (e) => {
            const input = e.target;
            if (input.type === 'checkbox' && input.classList.contains('visually-hidden')) {
                const chip = input.closest('.dg-popover-chip');
                if (chip) chip.classList.toggle('is-active', input.checked);

                // Auto-submit after brief visual feedback
                const form = input.closest('form');
                if (form) setTimeout(() => form.submit(), 250);
            }
        });

        /* ── Sort: auto-submit on radio change ──────────────────── */
        const sortForm = container.querySelector('.dg-filter-popover__form--sort');
        if (sortForm) {
            sortForm.addEventListener('change', (e) => {
                const radio = e.target;
                if (radio.name !== 'sort_by') return;

                // Update visual state
                sortForm.querySelectorAll('.dg-sort-option').forEach(opt => {
                    const inp = opt.querySelector('input[type="radio"]');
                    opt.classList.toggle('is-selected', inp === radio);
                });

                // Update chip label
                const chipLabel = document.getElementById('dg-sort-chip-label');
                if (chipLabel && radio.dataset.sortLabel) {
                    chipLabel.textContent = radio.dataset.sortLabel;
                }

                // Auto-submit after brief visual feedback
                setTimeout(() => sortForm.submit(), 200);
            });
        }
    })();


    /* ═══════════════════════════════════════════════════════════════
       STICKY CART BAR
       ═══════════════════════════════════════════════════════════════ */
    const stickyCartBar = document.getElementById('dg-sticky-cart-bar');
    const cartCountEl   = document.getElementById('dg-sticky-count');
    const cartTotalEl   = document.getElementById('dg-sticky-total');

    function updateStickyCart(cart) {
        if (!stickyCartBar) return;

        if (cart.item_count > 0) {
            stickyCartBar.classList.add('visible');
            const label = cart.item_count > 1 ? `${cart.item_count} art.` : `1 art.`;
            if (cartCountEl) cartCountEl.textContent = label;
            if (cartTotalEl) cartTotalEl.textContent = DG.utils.formatMoney(cart.total_price);
        } else {
            stickyCartBar.classList.remove('visible');
        }

        const threshold = parseInt(stickyCartBar.getAttribute('data-threshold'), 10) || 0;
        if (threshold > 0) {
            const progressBasis =
                typeof window.DG_fsProgressMerchandiseCents === 'function'
                    ? window.DG_fsProgressMerchandiseCents(cart)
                    : cart.total_price || 0;
            const remaining = threshold - progressBasis;
            const percent = Math.min(100, (progressBasis / threshold) * 100);

            const fillBar = document.getElementById('dg-delivery-fill');
            if (fillBar) fillBar.style.width = `${percent}%`;

            const textEl = document.getElementById('dg-delivery-text');
            if (textEl) {
                if (remaining > 0) {
                    textEl.innerHTML = `<svg class="dg-sticky-truck" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><span>Encore <strong>${DG.utils.formatMoney(remaining)}</strong></span>`;
                } else {
                    textEl.innerHTML = `<svg class="dg-sticky-truck dg-sticky-truck--done" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span><strong>Livraison gratuite!</strong></span>`;
                }
            }
        }
    }

    // Initial fetch
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
        .then(res => res.json())
        .then(cart => updateStickyCart(cart))
        .catch(() => {});

    // Listen for Global Cart Updates
    document.addEventListener('dg:cart:updated', (e) => {
        if (e.detail?.cart) updateStickyCart(e.detail.cart);
    });

    // View Cart Button: open drawer or redirect
    const stickyBtn = document.querySelector('.dg-sticky-btn');
    if (stickyBtn) {
        stickyBtn.addEventListener('click', (e) => {
            if (window.openCartDrawer) {
                e.preventDefault();
                window.openCartDrawer();
            }
        });
    }


    /* ═══════════════════════════════════════════════════════════════
       GRID COLUMN SELECTOR (if present)
       ═══════════════════════════════════════════════════════════════ */
    const gridContainer = document.querySelector('.dg-product-grid');
    const colBtns = document.querySelectorAll('.dg-toolbar__col-btn');

    if (gridContainer && colBtns.length > 0) {
        const savedCols = localStorage.getItem('dg-grid-cols');
        if (savedCols) {
            setGridCols(savedCols);
        } else {
            setGridCols(5, false);
        }

        colBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                setGridCols(btn.getAttribute('data-cols'), true);
            });
        });

        function setGridCols(cols, applyClass = true) {
            colBtns.forEach(btn => {
                btn.classList.toggle('active', btn.getAttribute('data-cols') == cols);
            });
            if (applyClass) {
                gridContainer.classList.remove(
                    'dg-grid-desktop-2', 'dg-grid-desktop-3', 'dg-grid-desktop-4',
                    'dg-grid-desktop-5', 'dg-grid-desktop-6'
                );
                gridContainer.classList.add(`dg-grid-desktop-${cols}`);
                localStorage.setItem('dg-grid-cols', cols);
            }
        }
    }

});
